// src/features/tidsregistering/services/dayOverviews.js
import { apiClient } from '../../../services/api/client';

const BASE = '/api/v1/tidsregistering/day-overviews';

export const dayOverviewsAPI = {
  getDayOverview: (dayOverviewId) =>
    apiClient.get(`${BASE}/${dayOverviewId}`),

  getDayOverviewForDate: (staffMemberId, date) =>
    apiClient.get(`${BASE}/staff/${staffMemberId}/date/${date}`),

  listForStaff: (staffMemberId, startDate, endDate) =>
    apiClient.get(`${BASE}/staff/${staffMemberId}`, { params: { start_date: startDate, end_date: endDate } }),

  listForDepartment: (startDate, endDate) =>
    apiClient.get(`${BASE}/department`, { params: { start_date: startDate, end_date: endDate } }),

  approveByUser: (dayOverviewId) =>
    apiClient.post(`${BASE}/${dayOverviewId}/approve/user`),

  approveByAdmin: (dayOverviewId, data) =>
    apiClient.post(`${BASE}/${dayOverviewId}/approve/admin`, data),

  revokeUserApproval: (dayOverviewId) =>
    apiClient.post(`${BASE}/${dayOverviewId}/revoke-user-approval`),

  updateTimeDetailCode: (timeDetailId, data) =>
    apiClient.put(`${BASE}/time-details/${timeDetailId}/code`, data),

  recalculateBalances: (dayOverviewId) =>
    apiClient.post(`${BASE}/${dayOverviewId}/recalculate-balances`),

  addComment: (dayOverviewId, data) =>
    apiClient.post(`${BASE}/${dayOverviewId}/comments`, data),
};
